import { render, staticRenderFns } from "./CreateRoomType.vue?vue&type=template&id=6546abe2&"
import script from "./CreateRoomType.vue?vue&type=script&lang=js&"
export * from "./CreateRoomType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateRoomType.vue"
export default component.exports